import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-23143f92"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login lg"
};
const _hoisted_2 = {
  class: "login-top"
};
const _hoisted_3 = {
  class: "login-form-p"
};
const _hoisted_4 = {
  class: "lg-div"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_6 = {
  class: "login-top"
};
const _hoisted_7 = {
  class: "forget-email-tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('Forget the password')), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Email Address')), 1), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.email = $event),
    type: "text",
    class: "lg-input",
    id: "username"
  }, null, 512), [[_vModelText, _ctx.email]]), _hoisted_5]), _createElementVNode("button", {
    class: "login-btn",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => _ctx.sendRetrievePasswordMailFn && _ctx.sendRetrievePasswordMailFn(...args))
  }, _toDisplayString(_ctx.$t('Send password reset email')), 1)], 512), [[_vShow, !_ctx.isSuccess]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("Forget the password")), 1), _createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString(_ctx.$t("The information needed to reset the password has been sent to you by mail.Please login")) + " ", 1), _createElementVNode("a", null, _toDisplayString(_ctx.email), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t('to view.')), 1)])], 512), [[_vShow, _ctx.isSuccess]])]);
}